export interface ICreatorGroup {
  date_modified: number;
  advertiser_id: number;
  brand_id: number;
  relation_ids: number[];
  name: string;
  id: number;
}
